<template>
  <div class="entry-print-container" id="print-entry">
    <div class="top-info">
      <div class="title">
        <span>入库单号：{{ entry.entryNo }}</span>
      </div>
      <div class="bar-code">
        <vue-barcode :value="entry.entryNo" format="CODE128" height="60px" width="2px">
          入库单号：{{ entry.entryNo }}
        </vue-barcode>
      </div>
    </div>

    <div class="middle-info">
      <div class="row">
        <div class="label">入库类型</div>
        <div class="value">{{ entry.entryType | getLabelByCodeFilter("ENTRY_TYPE") }}</div>
      </div>
      <div class="row">
        <div class="label">入库状态</div>
        <div class="value">{{ entry.entryStatus | getLabelByCodeFilter("ENTRY_STATUS") }}</div>
      </div>
      <div class="row">
        <div class="label">总数量</div>
        <div class="value">{{ entrySum }}</div>
      </div>
      <div class="row">
        <div class="label">总成本(元)</div>
        <div class="value">{{ entrySumPrice }}</div>
      </div>
      <div class="row">
        <div class="label">{{!["3", "4"].includes(entry.entryType) ? "供应商" : "客户"}}</div>
        <div class="value">{{ entry.customer.customerName }}</div>
      </div>
      <div class="row all">
        <div class="label">备注</div>
        <div class="value">{{ entry.remark }}</div>
      </div>
      <div class="row">
        <div class="label">创建人</div>
        <div class="value">{{ entry.creator.userName }}</div>
      </div>
      <div class="row">
        <div class="label">创建时间</div>
        <div class="value">{{ entry.createTime }}</div>
      </div>
      <div class="row">
        <div class="label">操作人</div>
        <div class="value bottom-line"></div>
      </div>
      <div class="row">
        <div class="label">操作时间</div>
        <div class="value bottom-line"></div>
      </div>
    </div>

    <div class="table-info">
      <table class="xiaobu-table">
        <thead class="table-header">
          <tr class="xiaobu-table-row">
            <th class="xiaobu-table-header-cell">商品名称</th>
            <th class="xiaobu-table-header-cell">规格</th>
            <th class="xiaobu-table-header-cell">保质期</th>
            <th class="xiaobu-table-header-cell">生产日期</th>
            <th class="xiaobu-table-header-cell">入库仓库</th>
            <th class="xiaobu-table-header-cell">成本单价(元)</th>
            <th v-if="['3', '4'].includes(entry.entryType)" class="xiaobu-table-header-cell">销售单价(元)</th>
            <th class="xiaobu-table-header-cell">入库数量</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr class="xiaobu-table-row" v-for="(item, index) in list" :key="index">
            <td class="xiaobu-table-row-cell">{{ item.goodsName }}</td>
            <td class="xiaobu-table-row-cell">{{ item.skuListStr }}</td>
            <td class="xiaobu-table-row-cell">{{ item.qualityGuaranteePeriod }}</td>
            <td class="xiaobu-table-row-cell">{{ item.manufactureDate }}</td>
            <td class="xiaobu-table-row-cell">{{ getWareHouseName(item.wareHouseId) }}</td>
            <td class="xiaobu-table-row-cell">{{ item.costPrice }}</td>
            <td v-if="['3', '4'].includes(entry.entryType)" class="xiaobu-table-row-cell">{{ item.salesPrice }}</td>
            <td class="xiaobu-table-row-cell">{{ item.entryNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// 条形码组件的value值不能有中文
import VueBarcode from "vue-barcode"
import printJS from "print-js"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import Decimal from "decimal.js"

export default {
  name: "EntryPrint",
  props: {
    spuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    entryData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    VueBarcode
  },
  watch: {
    spuList: {
      handler(val) {
        this.list = val
      },
      immediate: true
    },
    entryData: {
      handler(val) {
        this.entry = val
      },
      immediate: true
    }
  },
  computed: {
    entrySum() {
      return this.list.reduce((pre, cur) => {
        return pre + cur.entryNumber
      }, 0)
    },
    entrySumPrice() {
      const price = this.list.reduce((pre, cur) => {
        pre = new Decimal(pre) 
        const costPrice = new Decimal(cur.costPrice)
        const entryNumber = new Decimal(cur.entryNumber)
        return pre.plus(costPrice.times(entryNumber))
      }, 0)
      return price.toFixed(2) + "元"
    }
  },
  data() {
    return {
      list: [],
      entry: {
        entryNo: "",
        entryStatus: "",
        entryType: "",
        wareHouseId: "",
        wareHouseName: "",
        creator: {
          userName: ""
        },
        remark: ""
      }
    }
  },
  methods: {
    // 获取仓库名字
    getWareHouseName(val) {
      if (!val) {
        return ""
      }
      const wareHouseId = Array.isArray(val) ? val[val.length - 1] : val
      const list = getPathByTreeValue(this.wareHouseData, wareHouseId, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    print() {
      printJS({
        printable: "print-entry",
        type: "html",
        targetStyles: ["*"],
        scanStyles: false,
        style: `
          @page {
            size: A4 landscape;
          }
          .top-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .top-info .title {
            font-size: 28px;
            color: #000000;
          }

          .middle-info {
            width: 100%;
          }

          .middle-info:after {
            visibility: hidden;
            display: block;
            font-size: 0;
            content: " ";
            clear: both;
            height: 0;
          }

          .middle-info .row {
            width: 50%;
            min-height: 40px;
            line-height: 24px;
            padding: 8px 0;
            font-size: 18px;
            color: #000;
            float: left;
            display: flex;
          }

          .middle-info .row.all {
            width: 100%;
          }

          .middle-info .row .label {
            width: 168px;
            flex-shrink: 0;
          }

          .middle-info .row .value.bottom-line{
            position: relative;
          }
          .middle-info .row .value.bottom-line::after {
            content: '' !important;
            width: 256px;
            height: 1px;
            background: #000000;
            position: absolute;
            bottom: -8px;
            left: 0;
          }
          .table-info {
            margin-top: 20px;
          }
          .table-info .xiaobu-table {
            width: 100%;
          }
          .table-info .xiaobu-table .xiaobu-table-row .xiaobu-table-header-cell,
          .table-info .xiaobu-table .xiaobu-table-row .xiaobu-table-row-cell {
            height: 50px;
            line-height: 50px;
            text-align: center;
          }

          @media print {
            .entry-print-container {
              page-break-after: always;
            }
            .el-table__header-wrapper {
              display: table-header-group;
            }
            .el-table__body-wrapper {
              display: table-row-group;
            }
          }
        `
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-print-container {
  // 不在页面上显示  设置 display none 会导致打印不出来
  position: absolute;
  height: 0;
  overflow: hidden;

  .top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 28px;
      color: #000000;
    }
  }

  .middle-info {
    width: 100%;

    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }

    .row {
      width: 50%;
      min-height: 48px;
      line-height: 24px;
      padding: 12px 0;
      font-size: 18px;
      color: #000;
      float: left;
      display: flex;

      &.all {
        width: 100%;
      }

      .label {
        width: 168px;
        flex-shrink: 0;
      }
    }
  }

  .table-info {
    margin-top: 20px;

    .xiaobu-table {
      width: 100%;
      border: 1px solid #000;

      .xiaobu-table-row {
        border-bottom: 1px solid #000;

        .xiaobu-table-header-cell,
        .xiaobu-table-row-cell {
          height: 50px;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }

  @media print {
    .entry-print-container {
      page-break-after: always;
    }

    .el-table__header-wrapper {
      display: table-header-group;
    }

    .el-table__body-wrapper {
      display: table-row-group;
    }
  }
}
</style>